/**
 * Format a office title
 */
export default function officeName() {
  return function (input, onlyLongNames = false) {
    switch (input) {
      case "Associazione Biellese Dirigenti Aziente Industriali ":
        input = "Federmanager Biella";
        break;
      case "ALDAI - Associazione Lombarda Dirigenti Aziende Industriali":
        input = "ALDAI Milano";
        break;
      case "Associazione Dirigenti Aziende Industriali della Provincia di Ascoli Piceno":
        input = "Federmanager Ascoli Piceno";
        break;
      case "Associazione Toscana Dirigenti Aziende Industriali":
        input = "Federmanager Toscana";
        break;
      case "Federmanager Associazione Dirigenti Aziende Industriali Pavia":
        input = "Federmanager Pavia";
        break;
      case "Sindacato Dirigenti Aziende Industriali delle province di Ancona, Pesaro e Urbino":
        input = "Federmanager Ancona, Pesaro e Urbino";
        break;
    }
    // remove trailing federmanager string
    return onlyLongNames ? input : input.replace(/federmanager\s+/i, '');
  }
}


// WEBPACK FOOTER //
// ./client/app/filters/office_name.js